// @ts-nocheck
import { Box, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Loader from 'components/atoms/Loader';
import { useToast } from 'hooks';
import useCustomForm from 'pages/Forms/context/useCustomForm';
import useAttachment from 'pages/Forms/RegisterForm/CustomFormBuilder/components/UploadAttachments/hooks/useAttachment';
import ImageAttachment from './CommonAttachment/ImageAttachment';
import AttachmentInput from './AttachmentInput';
import { useNoteAndAttachmentFieldStyles } from './styles';
import { onSuccess, onFailure, attachmentHandler } from './AttachmentUtils';

const ImageAttachments = ({
  inputId,
  attachmentTitle,
  imageFileAttachment,
  setImageFileAttachment,
  field,
  handleDirty,
}) => {
  const {
    attachmentData,
    attachmentLoading,
    getFormData,
    saveAttachment,
    fetchAttachmentData,
    stripPrefixInAttachmentID,
  } = useAttachment();
  const toast = useToast();
  const classes = useNoteAndAttachmentFieldStyles();
  const [, { setAnswer }] = useCustomForm();
  const [values, setValues] = useState('');

  const handleSuccess = (data) => {
    onSuccess(data, setImageFileAttachment);
  };
  const handleFailure = (err) => onFailure(err, setValues);

  const handleAttachment = (e) => {
    const files = e.target.files;

    const isFileNameTooLong = Array.from(files).some(
      (file) => file.name?.length > 100,
    );

    if (isFileNameTooLong) {
      toast.error('File name should not exceed 100 characters.');
      return;
    }
    const isFileSizeExceeded = Array.from(files).some(
      (file) => file.size > 25 * 1024 * 1024,
    );

    if (isFileSizeExceeded) {
      toast.error('File size should not exceed 25MB.');
      return;
    }
    attachmentHandler(
      e.target.files,
      saveAttachment,
      getFormData,
      handleSuccess,
      handleFailure,
    );
    handleDirty();
  };
  const attachmentId = field?.answer?.map((item) => {
    const { id } = item;
    return stripPrefixInAttachmentID(id) || [];
  });
  useEffect(() => {
    if (field?.answer) {
      fetchAttachmentData({
        query: { attachments: attachmentId },
        skip: false,
      });
    }
  }, []);
  useEffect(() => {
    if (attachmentData) {
      const formattedAttachments = Object.keys(attachmentData).map(
        (itemId) => ({
          id: itemId,
          ...attachmentData[itemId],
        }),
      );
      setImageFileAttachment(formattedAttachments);
    }
  }, [attachmentData]);
  useEffect(() => {
    if (field?.type === 'images') {
      setAnswer(inputId, imageFileAttachment);
    }
  }, [imageFileAttachment]);
  return (
    <Box>
      <AttachmentInput
        classes={classes}
        attachmentHandler={handleAttachment}
        values={values}
        setValues={setValues}
        inputId={inputId}
        attachmentTitle={attachmentTitle}
      />
      <Box className={classes.multiAttachmentContainer}>
        {attachmentLoading ? (
          <Loader />
        ) : (
          <ImageAttachment
            setImageAttach={setImageFileAttachment}
            imageAttach={imageFileAttachment}
            handleDirty={handleDirty}
          />
        )}
      </Box>
    </Box>
  );
};

export default ImageAttachments;
